export const SHOPPING_CART = 'shoppingCart';

export const SHOPPING_CART_PED = 'shoppingCart_ped';

export const SHOPPING_CART_PRV = 'shoppingCart_prv';
